import React from 'react';
import { BsWhatsapp } from 'react-icons/bs';

const LetsTalk = () => {
  return (
    <>
      <div className='flex w-full flex-col items-center justify-between gap-6 bg-gradient-to-r from-[#495BFF] to-[#55E6A5] px-0 py-12 md:flex-row md:px-16'>
        {/* Left side text */}
        <h2 className=' text-center text-2xl font-bold text-white md:text-left md:text-3xl'>
          Are you planning any Domestic Trip ? Call us today or drop us an inquiry.
        </h2>

        {/* Right side button */}
        <a
          href='https://wa.me/919429620999'
          target='_blank'
          rel='noopener noreferrer'
        >
          <button className='text-dark flex items-center gap-2 rounded-lg bg-white px-6 py-3 font-semibold shadow-md transition duration-500 hover:opacity-90'>
            <BsWhatsapp className='text-xl text-[#25D366]' />
            Let’s talk
          </button>
        </a>
      </div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 1200 100'
        preserveAspectRatio='none'
        style={{
          backgroundColor: 'transparent',
          display: 'block',
          height: '30px',
          position: 'relative',
          top: '-1px',
          width: '100%',
        }}
      >
        <defs>
          <linearGradient
            id='myGradient'
            x1='0%'
            y1='0%'
            x2='100%'
            y2='0%'
          >
            <stop
              offset='0%'
              style={{ stopColor: '#495BFF' }}
            />
            <stop
              offset='100%'
              style={{ stopColor: '#55E6A5' }}
            />
          </linearGradient>
        </defs>

        <path
          d='M851.8,100c125,0,288.3-45,348.2-64V0H0v44c3.7-1,7.3-1.9,11-2.9C80.7,22,151.7,10.8,223.5,6.3C276.7,2.9,330,4,383,9.8 c52.2,5.7,103.3,16.2,153.4,32.8C623.9,71.3,726.8,100,851.8,100z'
          style={{ fill: 'url(#myGradient)' }}
        />
      </svg>
    </>
  );
};

export default LetsTalk;
